import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAZIAqZoBegsToG3-W3wezOfxoVcuUOUL4",
  authDomain: "seat-app-89001.firebaseapp.com",
  projectId: "seat-app-89001",
  storageBucket: "seat-app-89001.firebasestorage.app",
  messagingSenderId: "79938818101",
  appId: "1:679938818101:web:9ed44a2e8e1bef8f22f17c"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);